<ng-container *ngIf="!(this.isLoading && !this.allSolutionsToShow?.length); else sectionLoader">
  <div class="detail-content__section mb-5">
    <h5 class="detail-steps__title">Soluzioni disponibili</h5>
    <div class="c-detail-steps-solution">
      <div class="c-detail-steps-solution__wrapper">
        <h6>Scegli la tipologia di viaggio:</h6>
        <div class="c-detail-steps-solution__type">
        <span *ngIf="availableParentTypes?.soloSoggiorno" (click)="onClickOnParentType('NOTRANSPORT')"
              [class.active]="this.selectedTransportMode === 'NOTRANSPORT'">
            Solo Soggiorno
        </span>
          <span *ngIf="this.availableParentTypes?.voloSoggiorno" (click)="onClickOnParentType('FLIGHT')"
                [class.active]="this.selectedTransportMode === 'FLIGHT'">
          Volo + Soggiorno
        </span>
          <span *ngIf="this.availableParentTypes?.naveSoggiorno" (click)="onClickOnParentType('SHIP')"
                [class.active]="this.selectedTransportMode === 'SHIP'">
          Nave + Soggiorno
        </span>
        </div>
      </div>
    </div>

    <!--  Buttons dei mesi -->
    <div class="c-detail-steps-solution">
      <div class="c-detail-steps-solution__wrapper">
        <h6>Mese:</h6>
        <div class="c-detail-steps-solution__months">
        <span class="text-uppercase" *ngFor="let month of this.availableMonths"
              (click)="this.setSelectedMonth(month)"
              [class.active]="month.monthIndex === this.selectedMonth?.monthIndex">
          {{month.monthLabel}} {{month.year}}
        </span>
        </div>
      </div>
      <div class="c-detail-steps-solution__wrapper flex-grow-0">
        <h6>Durata notti:</h6>
        <div class="c-detail-steps-solution__nights">
        <span *ngFor="let nights of this.allDurationsForSelectedMonth"
              (click)="setSelectedDuration(nights)"
              [class.active]="nights === this.selectedDuration">
          {{nights}}
        </span>
        </div>
      </div>
    </div>

    <div *ngIf="this.allSolutionsToShow?.length"
         class="c-detail-price-grid">
      <div class="c-detail-price-grid__airports">
        <div class="c-detail-price-grid__dates">
          <span>&nbsp;</span>
        </div>

        <!-- ROW AEROPORTI -->
        <ng-container *ngIf="this.availableParentTypes?.voloSoggiorno && this.selectedTransportMode === 'FLIGHT'">
          <ng-container *ngFor="let departurePlaceId of this.allAirportsCodesForSelectedMonth">
            <div *ngIf="departurePlaceId && departurePlaceId > 1000000 && departurePlaceId < 2000000"
                 class="c-detail-price-grid__airports-item"
                 [class.active-row]="this.selectedSolution && departurePlaceId === this.selectedSolution.airport">
              <ng-container
                *ngIf=" (departurePlaceId | getDataFromMapping:'airportId' | async) as departurePlaceObject; else cellLoader">
                <span class="airports">
                  {{ departurePlaceObject?.Name }}
                </span>
                <span> ({{ departurePlaceObject?.Code}}) </span>
              </ng-container>

            </div>
          </ng-container>
        </ng-container>

        <!-- ROW PORTI -->
        <ng-container *ngIf="this.availableParentTypes?.naveSoggiorno && this.selectedTransportMode === 'SHIP'">
          <ng-container *ngFor="let departurePlaceId of this.allAirportsCodesForSelectedMonth">
            <div *ngIf="departurePlaceId && departurePlaceId > 2000000 && departurePlaceId < 3000000"
                 class="c-detail-price-grid__airports-item"
                 [class.active-row]="this.selectedSolution && departurePlaceId === this.selectedSolution.airport">
              <ng-container
                *ngIf=" (departurePlaceId | getDataFromMapping:'airportId' | async) as departurePlaceObject; else cellLoader">
                <span class="airports">
                  {{ departurePlaceObject?.Name }}
                </span>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>

        <!-- ROW Solo Soggiorno -->
        <div *ngIf="this.availableParentTypes?.soloSoggiorno && this.selectedTransportMode === 'NOTRANSPORT'"
             class="c-detail-price-grid__airports-item"
             [class.active-row]="this.selectedSolution && !this.selectedSolution.airport">
          <span>Solo Soggiorno</span>

        </div>
      </div>

      <swiper [config]="config" [(index)]="index" class="c-detail-price-grid__choices">

        <div *ngFor="let date of this.availableDatesForSelectedMonth" class="slide c-detail-price-grid__col">

          <!-- riga delle date -->
          <div class="c-detail-price-grid__dates">
            <span class="day-of-week">{{ date | dayjs: 'ddd'}}</span>
            <span class="day">{{ date | dayjs: 'DD'}}<span
              class="text-uppercase">{{ date | dayjs: 'MMM'}}</span></span>
          </div>
          <!-- fine riga delle date -->

          <!-- SOLUZIONI VOLO + SOGGIORNO -->
          <ng-container *ngIf="this.availableParentTypes?.voloSoggiorno && this.selectedTransportMode === 'FLIGHT'">
            <ng-container *ngFor="let departurePlaceId of this.allAirportsCodesForSelectedMonth">
              <div *ngIf="departurePlaceId && departurePlaceId > 1000000 && departurePlaceId < 2000000"
                   [class.active-row]="this.selectedSolution && departurePlaceId === this.selectedSolution.airport">
                <ng-container [ngTemplateOutlet]="bestMatchingSolutionCell"
                              [ngTemplateOutletContext]="{ date: date, departurePlaceId: departurePlaceId }">
                </ng-container>
              </div>
            </ng-container>
          </ng-container>

          <!-- SOLUZIONI NAVE + SOGGIORNO -->
          <ng-container *ngIf="this.availableParentTypes?.naveSoggiorno && this.selectedTransportMode === 'SHIP'">
            <ng-container *ngFor="let departurePlaceId of this.allAirportsCodesForSelectedMonth">
              <div *ngIf="departurePlaceId && departurePlaceId > 2000000 && departurePlaceId < 3000000"
                   [class.active-row]="this.selectedSolution && departurePlaceId === this.selectedSolution.airport">
                <ng-container [ngTemplateOutlet]="bestMatchingSolutionCell"
                              [ngTemplateOutletContext]="{ date: date, departurePlaceId: departurePlaceId }"></ng-container>
              </div>
            </ng-container>
          </ng-container>

          <!-- SOLUZIONI SOLO SOGGIORNO -->
          <ng-container
            *ngIf="this.availableParentTypes?.soloSoggiorno && this.selectedTransportMode === 'NOTRANSPORT'">
            <div [class.active-row]="this.selectedSolution && !this.selectedSolution.airport">
              <ng-container [ngTemplateOutlet]="bestMatchingSolutionCell"
                            [ngTemplateOutletContext]="{ date: date, departurePlaceId: null }"></ng-container>
            </div>
          </ng-container>
        </div>
      </swiper>
    </div>
  </div>
</ng-container>

<ng-template #bestMatchingSolutionCell let-date="date" let-departurePlaceId="departurePlaceId">
  <div
    *ngIf="this.allSolutionsToShow | holidayBestSolution : date : departurePlaceId as bestSolutionMatching; else noMatchingSolution;"
    class="c-detail-price-grid__price-item"
    [class.active]="bestSolutionMatching.solutionIdOrSource === selectedSolution?.solutionIdOrSource"
    (click)="setSelectedSolution(bestSolutionMatching)">

    <div class="c-detail-price-grid__price">
      <!--      Se NON c'è un caricamento in corso oppure se la soluzione ciclata non è quella selezionata -->
      <ng-container
        *ngIf="!this.isLoading || ( bestSolutionMatching.solutionIdOrSource !== selectedSolution?.solutionIdOrSource ); else cellLoader">
        <!-- Se per la soluzione in questione non è obbligatorio mostrare solo il prezzo live oppure se questo è già stato calcolato -->
        <ng-container
          *ngIf="!bestSolutionMatching.priceShownMustBeLive || bestSolutionMatching.isShownPriceLive || bestSolutionMatching.solutionIdOrSource === selectedSolution?.solutionIdOrSource; else showPriceMessage">
          <small>da&nbsp;</small>
          <span *ngIf="bestSolutionMatching.totalPrice">{{bestSolutionMatching.totalPrice | number:'1.0-0'}}
            €<small class="price-title-guests">(totale)</small>
          </span>
          <span *ngIf="!bestSolutionMatching.totalPrice && bestSolutionMatching.price">
            {{bestSolutionMatching.price | number:'1.0-0'}}
            €<small class="price-title-guests">(per persona)</small>
          </span>
        </ng-container>
      </ng-container>
    </div>

  </div>
</ng-template>

<!--Riga vuota (nessuna soluzione per data/aeroporto)-->
<ng-template #noMatchingSolution>
  <div class="c-detail-price-grid__price-item not-available-empty"></div>
</ng-template>

<ng-template #sectionLoader>
  <div class="c-detail-price-grid__loader-wrapper">
    <app-element-loader
      [loadingStatus]="true"
      [loadingMessage]="'Stiamo caricando i prezzi aggiornati'">
    </app-element-loader>
  </div>
</ng-template>

<!--Loader su singola cella-->
<ng-template #cellLoader>
  <span class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true">
  </span>
</ng-template>

<ng-template #showPriceMessage>
  <span> Disponibile
    <small class="price-title-guests">vedi prezzo</small>
  </span>
</ng-template>


